import HmsEntityTableController from 'components/HmsEntityTableController';
import useEntities from 'hooks/useEntities';

const Awards = () => {
  const entities = useEntities();
  const filterGroups = null;
  const showColumns = [
    'NameWithLogo', 
    'nick', 
    'short', 
    'description', 
    'foundDate', 
    'type',
  ];

  return (
    <HmsEntityTableController
      entity={entities.Award}
      filterGroups={filterGroups}
      showColumns={showColumns}
    />
  )
}

export default Awards